import React from "react";
import { func, array, bool, number, oneOfType } from "prop-types";
import DownloadTestResultsComponent from "../actionComponents/DownloadTestResultsComponent";

const DownloadTestResults = ({
  changeAction,
  onDownloadResults,
  candidateIds,
  showWorkStyles,
  candidateStatus,
  isEPPCompleted,
  isBulkAction = false,
  areProctoringRecordingsAvailable = false,
}) => (
  <DownloadTestResultsComponent
    changeAction={changeAction}
    onDownloadResults={onDownloadResults}
    candidateIds={candidateIds}
    showWorkStyles={showWorkStyles}
    candidateStatus={candidateStatus}
    isEPPCompleted={isEPPCompleted}
    isBulkAction={isBulkAction}
    areProctoringRecordingsAvailable={areProctoringRecordingsAvailable}
  />
);

DownloadTestResults.propTypes = {
  changeAction: func,
  onDownloadResults: func,
  candidateIds: array,
  showWorkStyles: bool,
  candidateStatus: number,
  isEPPCompleted: oneOfType([bool, number]),
  isBulkAction: bool,
  areProctoringRecordingsAvailable: bool,
};

export default DownloadTestResults;
